import { render, staticRenderFns } from "./RoleLevelsView.vue?vue&type=template&id=4960a77d&"
import script from "./RoleLevelsView.vue?vue&type=script&lang=js&"
export * from "./RoleLevelsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports